module.exports = __webpack_public_path__ + "img/fig10.89292f85.jpg";